export default "__VITE_ASSET__DZYDsoH3__"